import io from 'socket.io-client';
import axios from 'axios';
import {checkCookie, deleteAllCookies, eraseCookie, getCookie} from "ubs-framework/v2/common/function";
import {bytesToSize, Decryption, detectDevice, Encryption, findUserFunction, showToastSuccess} from "ubs-framework/v2/common/function";
import {ERROR} from "../../common/string";
import {planMerger} from 'ubs-framework/v2/common/function';
import {allowDuplicatesEvents, FIND_USER_KEY_NAME} from "../../common/constant";

let socket;

const api = axios.create();
api.defaults.baseURL = process.env.REACT_APP_RECRUIT_API_URL;

const api2 = axios.create();
api2.defaults.baseURL = window.location.href.includes('.superworks.com') ? 'https://apicall2.superworks.com' :  process.env.REACT_APP_RECRUIT_API_URL;

const prepareData = (event, data) => {
    console.log(`%c(((${event})))`, 'font-size: 14px; color: #CC7A00;',data);
    return Encryption({event, data});
};

const requestTracker = new Map();
const isDuplicateRequest = (event, data) => {
    const requestKey = JSON.stringify({ event, data });
    if (requestTracker?.has(requestKey)) return true;
    requestTracker?.set(requestKey, true);
    setTimeout(() => {
        if(requestTracker instanceof Map) requestTracker?.delete(requestKey);
    }, 500); // Adjust timeout based on the expected time for requests to complete
    return false;
};

export const sendData = (en, data) => {
    const events = ['authenticate', 'onboardingAuth', 'refreshToken']
    if (!events.includes(en) && !socket?.isAuthenticated) return;
    if(!allowDuplicatesEvents?.includes(en)){
        if (isDuplicateRequest(en, data)) return
    }
    if (socket?.connected) socket.emit('request', prepareData(en, data));
};

function roughSizeOfObject(object) {

    let objectList = [];

    let recurse = (value) => {
        let bytes = 0;

        if (typeof value === 'boolean') {
            bytes = 4;
        } else if (typeof value === 'string') {
            bytes = value.length * 2;
        } else if (typeof value === 'number') {
            bytes = 8;
        } else if
        (
            typeof value === 'object'
            && objectList.indexOf(value) === -1
        ) {
            objectList[objectList.length] = value;

            for (let i in value) {
                bytes += 8; // an assumed existence overhead
                bytes += recurse(value[i])
            }
        }

        return bytes;
    }

    return recurse(object);
}

export const socketConnect = (dispatch, history, next) => {
    /**===================================================================
     Socket connection
     ===================================================================
     + Socket listeners
     */

    socket = io.connect(`${process.env.REACT_APP_RECRUIT_SOCKET_URL}?token=${getCookie('ubs_token')}&flag=ATS&orgId=${window?.location?.pathname?.split('/')[1]}`, {
        "transports": ['websocket'],
        closeOnBeforeunload: false
    });
    socket.on('connect', () => {
        dispatch({type: 'SOCKET_CONNECTION', payload: socket.id});
        next(socket.connected);
    });
    socket.on('response', response => {let res;
        if (typeof response === 'string') res = Decryption(response);
        else res = response;
        console.log(`%c ${res.code} | ${res.event} | ${bytesToSize(roughSizeOfObject(res))} ===>`, `font-size: 14px; color: ${res?.error ? "red" : '#60b158'}; background-color: rgba(34, 101, 0, 0.1)}`, res);

        // Force-logout broadcasts are owned by the framework's UForceLogout component.
        // Yield here so legacy alert / redirect paths do not run alongside the popup.
        if (res && res.data && res.data.forceLogout === true) {
            try { window.dispatchEvent(new CustomEvent('ubs:force-logout', { detail: res })); } catch (e) { /* dispatch must not block */ }
            return;
        }
        // Phase-7 wallet dunning: the backend answers every company event with 402 +
        // billingBlocked for non-owner users of a payment-blocked company - show the
        // full-screen error page (same mechanism as removed product access).
        if (res?.data?.billingBlocked === true && (res?.code === 402 || res?.event === 'billing|blocked')) {
            // structured blocked page: reason on its own line (esc = HTML-escape, the
            // reason is admin-typed text and UErrorPage renders description as HTML)
            const esc = (s) => String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            const bd = res?.data || {};
            dispatch({type: 'SET_ERROR', payload: {
                title: bd.blockTitle || 'Company Access Suspended',
                description: esc(bd.blockMessage || bd.error || "Your company's Superworks access is paused. Please contact your administrator.")
                    + (bd.blockReason ? '<br/><br/><strong>Reason:</strong> ' + esc(bd.blockReason) : '')
                    + (bd.blockContact ? '<br/><br/>' + esc(bd.blockContact) : ''),
                type: 'full'
            }});
            return;
        }
        if (res) {
            if (!res?.error) {
                if (res?.data?.error) {
                    // alert(res.data.error);
                } else {
                    findUserFunction(res?.data, FIND_USER_KEY_NAME, dispatch, res?.event);
                    switch (res.event) {
                        case 'authenticate':
                            const planAccess = planMerger(res?.data?.planAccess, res?.data?.productAccess, res?.data?.isAdmin)
                            if (planAccess?.recruit?.default?.access) {
                                if (!!res.data.orgId) {
                                    const orgId = window.location.pathname.split('/');
                                    if ((orgId[1] && orgId[1] !== res.data.orgId) || !orgId[2] || (orgId[2] && orgId[2].length === 0)) history.push(`/${res.data.orgId}`);
                                    socket.isAuthenticated = true
                                    dispatch({type: 'AUTHENTICATE', payload: res.data});
                                    sendData('ats|master|get', {});
                                    sendData('ats|setting|integration|get', {})
                                } else dispatch({type: 'SET_ERROR', payload: {description: ERROR.authenticate, type: 'full'}});
                            } else dispatch({type: 'SET_ERROR', payload: {description: ERROR.removeProductAccess, type: 'full'}});
                        break;
                        case 'onboardingAuth': {
                                socket.isAuthenticated = true
                                dispatch({type: 'ON_BOARDING_AUTHENTICATE', payload: res.data});
                                break;
                        }
                        case 'productPlanUpdate':
                        case 'productAccessUpdate': {
                            if (typeof res?.data?.recruit === 'boolean' && !res?.data?.recruit) {
                                dispatch({type: 'SET_ERROR', payload: {description: ERROR.removeProductAccess, type: 'full'}});
                                dispatch({type: 'PRODUCT_ACCESS_REMOVED', payload: res.data});
                            }
                            break;
                        }
                        case 'ats|master|get':
                            dispatch({type: 'GET_ATS_MASTER_DATA', payload: res.data});
                            sendData('hrms|master|globalConversation|unreadMessageFlag', {});
                            sendData('master|paymentbar|content|get', {orgId: window?.location?.pathname?.split('/')[1]});
                            break;
                        case 'master|paymentbar|content|get':
                            dispatch({type: 'GET_PAYMENT_BAR_DATA', payload: res.data});
                            break;
                        case 'hrms|request|masterData|update':
                            dispatch({type: 'UPDATE_ATS_MASTER_DATA', payload: res.data});
                            break;
                        case 'getWorkspaceList':
                            dispatch({type: 'SET_WORKSPACE_LIST', payload: res.data.list});
                            break;
                        case 'readProductVideo':
                            dispatch({type: 'SET_PRODUCT_VIDEO', payload: res.data});
                            break;
                        case 'getLatestVersion': {
                            dispatch({type: 'SET_LATEST_VERSION', payload: res.data, initial: true});
                            break;
                        }
                        case 'updateAppVersion':
                            dispatch({type: 'SET_LATEST_VERSION', payload: res.data});
                            break;
                        case 'hrms|master|uac|reload':
                            dispatch({type: 'SET_UAC_UPDATE', payload: res.data});
                            break;
                        case 'hrms|master|get': {
                            dispatch({type: 'GET_MASTER_INFO_UPDATE', payload: res.data})
                            break;
                        }
                        case 'ats|master|candidateList': {
                            dispatch({type: 'GET_CANDIDATE_INFO_UPDATE', payload: res.data})
                            break;
                        }
                        case 'ats|setting|subDomain|fetch': {
                            dispatch({type: 'SET_SUB_DOMAIN', payload: res.data?.domainInfo})
                            break;
                        }
                        case 'hrms|dropList|get': {
                            if (res?.data?.listType === 4 && res?.data?.rows?.length) dispatch({type: 'GET_MASTER_INFO_UPDATE', payload: {users: res?.data?.rows}})
                            break;
                        }
                        case 'ats|interview|add': {
                            showToastSuccess('Interview added successfully.');
                            break;
                        }
                        case 'ats|interview|update': {
                            if(res?.data?.interviewInfo?.status !== 3) showToastSuccess('Interview updated successfully.');
                            break;
                        }
                        case 'ats|interview|delete': {
                            showToastSuccess('Interview deleted successfully.');
                            break;
                        }
                        case 'ats|candidate|interviewForm|send': {
                            showToastSuccess('Interview form sent successfully.');
                            break;
                        }
                        case 'atsUpdateNotificationCount':
                            dispatch({type: 'UPDATE_NOTIFICATION_COUNT', payload: res?.data?.notificationCount});
                            break;
                        case 'ats|candidate-reminder|show':
                            dispatch({type: 'SHOW_REMINDER', payload: res?.data});
                            break;
                        case 'ats|candidate-reminder|fetch':
                            dispatch({type: 'SHOW_REMINDER', payload: res?.data?.candidateReminderInfo});
                            break;
                        case 'ats|setting|integration|get':
                            dispatch({type: 'SET_INTEGRATION', payload: res?.data});
                            break;
                        case 'ats|setting|integration|update':
                            dispatch({type: 'UPDATE_INTEGRATION', payload: res?.data});
                            break;
                        case 'ats|setting|integration|remove':
                            dispatch({type: 'REMOVE_INTEGRATION', payload: res?.data?.updateIntergration});
                            break;
                        case 'ats|candidate-reminder|delete': {
                            showToastSuccess('Reminder deleted successfully.');
                            break;
                        }
                        case 'ats|candidate-reminder|add': {
                            showToastSuccess('Reminder added successfully.');
                            break;
                        }
                        case 'ats|candidate-reminder|update': {
                            showToastSuccess('Reminder updated successfully.');
                            break;
                        }
                        default:
                            return true;
                    }

                }
            } else {
                switch (res.code) {
                    case 404:
                        if (res.event === 'logout' && res.message === 'Not Found') onLogout();
                        break;
                    case 401:
                        onLogout();
                        break;
                    default:
                        return true;
                }
            }
        }
    });

    socket.on("disconnect", (res) => {
        socket.isAuthenticated = false
        dispatch({type: 'SOCKET_CONNECTION', payload: socket.id});
    });
};

export const onLogout = async (isPreBoarding = false, orgId = false) => {
    const device_token = ['fcm_chat', 'fcm_hrms', 'fcm_pms', 'fcm_recruit', 'fcm_asset'].reduce((tokens, cookie) => {
        const cookieValue = getCookie(cookie);
        if (cookieValue) tokens.push(cookieValue);
        return tokens;
    }, []);

    sendData('logout', { device_token, platform: detectDevice(true)});
    const cookiesToErase = ['ubs_token', 'fcm_chat', 'fcm_hrms', 'fcm_pms', 'fcm_recruit', 'fcm_asset', 'preBoardingId'];
    localStorage.clear();
    deleteAllCookies();
    cookiesToErase.forEach(eraseCookie);

    if(isPreBoarding && orgId){
        setTimeout(() => {
            window.location.href = `${process.env.REACT_APP_ACCOUNT_MODULE_URL}/${orgId}/preboarding/login`
        }, 500);
    }else{
        setTimeout(() => {
            window.location.href = process.env.REACT_APP_ACCOUNT_MODULE_URL;
        }, 500);
    }

};

export {socket, api, api2};
